<template>
  <div class="contents new-style">
    <Row class="AppHeader bg-16151A min-W w-100b text-white ">
      <Row class="f-1 flow-atow h-100b min-w-0px">
        <Link to="/" class="pointer">
          <img
            v-inmodule="['/home']"
            alt="BiFinance"
            class="w-110 h-24 m-r-20"
            src="@/image/home/logo-dark.webp"
          >
        </Link>
        <Row class="nav-menu flow-atow text-white min-w-0px overflow-x-auto overflow-y-hidden" :style="navMenuStyle" y="c">
          <div
            id="menu-item-quotes"
            v-inmodule="['/quotes']"
            class="nav-item shrink-0"
            :class="{ 'is-active': defaultActive === 'quotes' }"
          >
            <el-dropdown
              :teleported="true"
              :hide-timeout="200"
              popper-class="dropdown-no-arrow header-dropdown"
              @visible-change="(v) => quotesArrow = v"
            >
              <Row class="text-white header-hover-bg  whitespace-nowrap" x="c" y="c">
                <span class="t-d font-14 bold m-r-8">{{ $t('header.quotes') }}</span>
                <IconSvg class="t-d font-8 pointer" :class="quotesArrow ? 'rotateZ-180' : ''" :name="'icon-IconDown_Menu'" />
              </Row>
              <template #dropdown>
                <Column class="w-min-280" y="s">
                  <Row v-to="'/quotes/odds'" class="w-100b h-64 p-lr-12 pointer label font-w-400 bg-hover-lInfo radius-4 m-b-10" y="c">
                    <img class="w-24 m-r-9" src="@/image/home/a-jihui1.png">
                    <Column>
                      <span class="label">{{ $t('trade.opportunities') }}</span>
                      <span class="label-sm text-9b">{{ $t('trade.timelySeizeNewMarketOpportunities') }}</span>
                    </Column>
                  </Row>
                  <Row v-to="'/quotes'" class="w-100b h-64 p-lr-12 pointer label font-w-400 bg-hover-lInfo radius-4" y="c">
                    <img class="w-24 m-r-9" src="@/image/home/shichang1.png">
                    <Column>
                      <span class="label">{{ $t('header.quotes') }}</span>
                      <span class="label-sm text-9b">{{ $t('trade.viewLatestCryptoPricesVolume') }}</span>
                    </Column>
                  </Row>
                </Column>
              </template>
            </el-dropdown>
          </div>

          <!-- <el-menu-item
            id="menu-item-c2c"
            v-inmodule="['/c2c']"
            class="nav-item "
            :style="header_icon_gap"
            index="c2c"
          >{{ $t('public.buyCoins') }}</el-menu-item> -->
          <Row
            id="menu-item-trade"
            v-inmodule="['/trade']"
            class="nav-item shrink-0"
            :class="{ 'is-active': defaultActive === 'trade' }"
            x="c"
            y="c"
            @click="selectMenu('trade')"
          >
            <Row class="header-hover-bg whitespace-nowrap" x="c" y="c">
              {{ $t('header.spot') }}
            </Row>
          </Row>
          <!-- v-if="env.MODE!=='production'" -->
          <!-- S合约 -->
          <Row
            v-if="isS"
            id="menu-item-futures"
            v-inmodule="['/futures']"
            class="nav-item shrink-0"
            :class="{ 'is-active': defaultActive === 'futures' }"
            x="c"
            y="c"
            @click="selectMenu('futures')"
          >
            <Row class="position-r header-hover-bg whitespace-nowrap" x="c" y="c">
              {{ $t('futures.yfutures') }}
            </Row>
          </Row>

          <Row
            id="menu-item-financial"
            v-inmodule="['/financial']"
            class="nav-item shrink-0"
            :class="{ 'is-active': defaultActive === 'financial' }"
            x="c"
            y="c"
            @click="selectMenu('financial')"
          >
            <Row class="header-hover-bg whitespace-nowrap" x="c" y="c">{{ $t('header.financial') }}</Row>
          </Row>

          <Row
            id="menu-item-superNode"
            class="nav-item shrink-0"
            :class="{ 'is-active': defaultActive === 'superNode' }"
            x="c"
            y="c"
            @click="selectMenu('superNode')"
          >
            <Row class="header-hover-bg whitespace-nowrap" x="c" y="c">
              <img class="w-20 h-20 m-r-4 shrink-0" src="@/image/user/hot.gif">
              <span class="label">{{ $t('superNode.menuTitle') }}</span>
            </Row>
          </Row>

          <!-- ECO 专区 -->
          <Row
            id="menu-item-eco"
            class="nav-item shrink-0"
            :class="{ 'is-active': defaultActive === 'eco' }"
            x="c"
            y="c"
            @click="selectMenu('eco')"
          >
            <Row class="header-hover-bg whitespace-nowrap" x="c" y="c">
              <img style="width: 18px; height: 18px;" class="m-r-4 shrink-0" src="@/image/activity/eco/eco-entry-icon.svg">
              <span class="label">{{ $t('header.ecoZone') }}</span>
            </Row>
          </Row>

          <div
            id="menu-item-activity"
            class="nav-item shrink-0"
          >
            <el-dropdown
              class=""
              :teleported="true"
              :hide-timeout="200"
              popper-class="dropdown-no-arrow header-dropdown header-activity-dropdown"
              @visible-change="(v) => eventsArrow = v"
            >
              <Row class="text-white header-hover-bg  whitespace-nowrap" x="c" y="c">
                <span class="t-d font-14 bold m-r-8">{{ $t('public.more') }}</span>
                <IconSvg class="t-d font-8 pointer" :class="eventsArrow ? 'rotateZ-180' : ''" :name="'icon-IconDown_Menu'" />
              </Row>

              <template #dropdown>
                <el-scrollbar max-height="560px" class="header-activity-dropdown-scrollbar">
                  <Row class="p-tb-2 p-lr-12 header-activity-dropdown-content" y="s">
                    <Column class="w-220" y="s">
                      <span class="c-cs-9b font-12 m-tb-12 p-lr-14 font-w-400" y="c">{{ $t('public.products') }}</span>
                      <Row class="w-100b h-44 p-lr-14 pointer label font-w-500 bg-hover-lInfo radius-4" y="c" @click="() => toRouter('/coinStockConvert')">
                        <img class="w-24 m-r-9" src="@/image/stock/quickChange.png">
                        <span flex-1 class="ellipsis">{{ $t('stock.quickConvert') }}</span>
                      </Row>
                      <Row class="w-100b h-44 p-lr-14 pointer label font-w-500 bg-hover-lInfo radius-4" y="c" @click="() => toRouter('/ipo')">
                        <img class="w-24 m-r-9" src="@/image/common/ipo.png">
                        <span flex-1 class="ellipsis">IPO</span>
                      </Row>
                      <Row class="w-100b h-44 p-lr-14 pointer label font-w-500 bg-hover-lInfo radius-4" y="c" @click="() => toRouter('/launchpad')">
                        <img class="w-24 m-r-9" src="@/image/common/launchpad.png">
                        <span flex-1 class="ellipsis">Launchpad</span>
                      </Row>
                      <Row class="w-100b h-44 p-lr-14 pointer label font-w-500 bg-hover-lInfo radius-4" y="c" @click="() => toRouter('/vote')">
                        <img class="w-24 m-r-9" src="@/image/home/vote.svg">
                        <span flex-1 class="ellipsis">{{ $t('header.vote') }}</span>
                      </Row>
                      <Row class="w-100b h-44 p-lr-14 pointer label font-w-500 bg-hover-lInfo radius-4" y="c" @click="() => toRouter('/newcomerBenefits')">
                        <img class="w-24 m-r-9" src="@/image/newbir-rewards.svg">
                        <span flex-1 class="ellipsis">{{ $t('activity.timeNewbieBenefits2') }}</span>
                      </Row>
                      <Row class="w-100b h-44 p-lr-14 pointer label font-w-500 bg-hover-lInfo radius-4" y="c" @click="() => toRouter('/rebate', { requireLogin: true, redirect: '/rebate' })">
                        <img class="w-24 m-r-9" src="@/image/home/invateRebate.png">
                        <span flex-1 class="ellipsis">{{ $t("wallet.invateRebate") }}</span>
                      </Row>
                      <Row class="w-100b h-44 p-lr-14 pointer label font-w-500 bg-hover-lInfo radius-4" y="c" @click="() => toRouter('/agentApplication')">
                        <img class="w-24 m-r-9" src="@/image/home/partnerRecruitment.png">
                        <span flex-1 class="ellipsis">{{ $t(`agent.partnerRecruitment`) }}</span>
                      </Row>
                      <Row v-to="'/bft'" class="w-100b h-44 p-lr-14 pointer label font-w-500 bg-hover-lInfo radius-4" y="c">
                        <img class="w-24 m-r-9" src="@/image/home/aboutBFT.png">
                        <span flex-1 class="ellipsis">{{ $t('bft.aboutBFT') }}</span>
                      </Row>
                    </Column>
                    <Column class="f-1 " y="s">
                      <span class="c-cs-9b font-12 m-tb-12 p-lr-14 font-w-400" y="c">{{ $t('header.platformActivity') }}</span>
                      <Row
                        v-for="(item) in landingPageList"
                        :key="item.id"
                        v-to="`/commonActivity?id=${item.id}`"
                        class="w-220 h-44 p-lr-14 pointer label font-w-400 bg-hover-line radius-4 bg-hover-lInfo"
                        :class="landingPageListClassName(item)"
                        x="sb"
                      >
                        <div class="flex-1 header-ellipsis">{{ item.title }}</div>
                        <span class="font-11 landingPageList-status m-l-8">
                          <span v-if="landingPageListClassName(item)==='Ongoing'" class="Ongoing">{{ $t('activity.Ongoing') }}</span>
                          <span v-if="landingPageListClassName(item)==='Ended'" class="Ended">{{ $t('activity.Ended') }}</span>
                          <span v-if="landingPageListClassName(item)==='Upcoming'" class="Upcoming">{{ $t('activity.Upcoming') }}</span>
                        </span>
                      </Row>
                    </Column>
                    <!-- <Column class="f-1" y="s">
                      <span class="c-cs-9b font-12 m-tb-12 p-lr-14 font-w-400" y="c">{{ $t('header.newCoinActivity') }}</span>
                      <Row
                        v-for="(item, index) in newCoinActivities"
                        :key="index"
                        class=" h-44 w-220 p-lr-14 pointer label font-w-400 bg-hover-line radius-4 bg-hover-lInfo"
                        y="c"
                      >
                        <div class="flex-1 header-ellipsis" @click="openLink(item.link)">{{ item.title }}</div>
                      </Row>
                    </Column> -->
                  </Row>
                </el-scrollbar>
              </template>
            </el-dropdown>
          </div>

          <!-- 世界杯菜单暂时隐藏
          <Row
            id="menu-item-worldCup"
            class="nav-item shrink-0"
            :class="{ 'is-active': defaultActive === 'worldCup' }"
            x="c"
            y="c"
            @click="selectMenu('worldCup')"
          >
            <Row class="header-hover-bg whitespace-nowrap" x="c" y="c">
              <img class="w-18px h-18px m-r-4 shrink-0" src="@/image/activity/worldCup/worldcup.gif">
              <span class="label">{{ $t('header.worldCup') }}</span>
            </Row>
          </Row> -->

          <div
            id="menu-item-stock"
            v-inmodule="['/coinStock', '/coinStockTrade', '/coinStockFutures', '/coinStockConvert', '/ipo', '/bffund']"
            class="nav-item shrink-0"
            :class="{ 'is-active': defaultActive === 'coinStock' }"
          >
            <el-dropdown
              :teleported="true"
              :hide-timeout="200"
              popper-class="dropdown-no-arrow header-dropdown header-stock-dropdown"
            >
              <div class="nav-item-stock ml-6px shrink-0" @click="selectMenu('coinStock')">
                <StockButton />
              </div>

              <template #dropdown>
                <Column class="w-220px" y="s">
                  <Row
                    v-for="item in stockMenuList"
                    :key="item.key"
                    class="w-100b h-44px px-14px cursor-pointer label font-w-500 bg-hover-lInfo rounded-4px"
                    y="c"
                    @click="selectMenu(item.key)"
                  >
                    <span class="ellipsis weight-500">{{ item.label }}</span>
                    <img
                      v-if="item.iconImg"
                      :src="item.iconImg"
                      class="w-16px h-16px ml-6px shrink-0"
                      alt=""
                    >
                    <span
                      v-if="item.badge"
                      class="h-16px px-4px ml-6px rounded-4px bg-06F0C6 text-16151A text-10px weight-600 lh-16px"
                    >
                      {{ item.badge }}
                    </span>
                  </Row>
                </Column>
              </template>
            </el-dropdown>
          </div>
        </Row>
      </Row>
  <!-- <Row class="w-140 h-40 p-lr-20 box-border label c-info" y="c">
        {{ $t('public.languageFallbackTest') }}
      </Row> -->
      <rightMenu :isSmallScreen="isSmallScreen" gap="0" />
    </Row>
    <Row class="w-100% h-64" />
  </div>
</template>

<script setup>
import rightMenu from './rightMenu/index.vue'
import QuerySymbol from './QuerySymbol.vue'
import StockButton from '@/layout/appHeader/components/StockButton.vue'
import hotIcon from '@/image/user/hot.gif'
import { getBusinessPath } from '@/utils/localeRoute.js'
import { THEME_DARK } from '@/hook/useAppColorMode.js'

const props = defineProps({
  gap: {
    type: [String, Number],
    default: '0',
  },
})

const userStore = useUserStore()
const configStore = useConfigStore()
const tradeStore = useTradeStore()
const futuresStore = useFuturesStore()
const mailStore = useMailStore()
const route = useRoute()
const businessPath = $computed(() => getBusinessPath(route.path))

const quotesArrow = $ref(false)
const eventsArrow = $ref(false)

const env = $computed(() => {
  return import.meta.env
})

const diaMailSetData = reactive({
  show: false
})

const diaTradeStyleSetData = reactive({
  show: false
})

const menuConfig = {
  eco: { path: '/ecoV2/ecoHome', requireLogin: true },
  worldCup: { path: '/activity/worldCup' },
  newcomerBenefits: { path: '/newcomerBenefits' },
  superNode: { path: '/superNode' },
  coinStock: { path: '/coinStock' },
  coinStockTrade: { path: '/coinStockTrade' },
  coinStockFutures: { path: '/coinStockFutures' },
  coinStockConvert: { path: '/coinStockConvert' },
  vote: { path: '/vote' },
  launchpad: { path: '/launchpad' },
  ipo: { path: '/ipo' },
  bifund: { path: '/bffund' },
  financial: { path: '/financial' },
  home: { path: '/home' },
  c2c: { path: '/c2c' },
  trade: { path: () => `/trade?symbol=${tradeStore.symbol}` },
  futures: { path: () => `/futures?symbol=${futuresStore.symbol}` },
  registerSendBTC: { path: '/registerSendBTC' },
  couponCenter: { path: '/psersonalCenter/couponCenter' },
  promotionPlan: { path: '/psersonalCenter/promotionPlan' },
  christmas: { path: '/christmas' },
}

const stockMenuList = $computed(() => [
  { label: $t('stock.stockIntroduce'), key: 'coinStock' },
  { label: $t('stock.stockTab'), key: 'coinStockTrade' },
  { label: $t('stock.stockContractTab'), key: 'coinStockFutures' },
  { label: $t('stock.stockIpoNav'), key: 'ipo', iconImg: hotIcon },
  { label: $t('stock.bifundNav'), key: 'bifund', badge: $t('stock.bifundTag') },
])

const tips = $computed(() => {
  if (userStore?.info?.nickName) {
    return userStore?.info?.nickName
  }
  if (userStore?.info?.phone) {
    return $f.hidePhone(userStore?.info?.phone)
  }
  if (userStore?.info?.email) {
    return $f.hideEmail(userStore?.info?.email)
  }
})

const isS = $computed(() => {
  if (!['uat', 'production'].includes(envMode)) {
    return true
  } else if (proj === SEPRJ || !proj) {
    return true
  } else {
    return false
  }
})

const isF = $computed(() => {
  if (!['uat', 'production'].includes(envMode)) {
    return true
  } else if (proj === FUPRJ) {
    return true
  } else {
    return false
  }
})

const selectMenu = (key) => {
  const config = menuConfig[key]
  if (!config) return

  const path = typeof config.path === 'function' ? config.path() : config.path

  if (config.requireLogin) {
    toRouter(path, { requireLogin: true, redirect: path })
  } else {
    toRouter(path)
  }
}

let letfIconGap = $ref(28)
let rightIconGap = $ref(14)
let isSmallScreen = $ref(window.innerWidth <= 1590)
onBeforeMount(() => {
  eventBus.on('onResize', e => {
    isSmallScreen = window.innerWidth <= 1590
    if (window.innerWidth > 1440) {
      letfIconGap = 28
      rightIconGap = 14
    } else {
      letfIconGap = 20
      rightIconGap = 12
    }
  })
})

const navMenuStyle = $computed(() => {
  const gap = props.gap === '' ? letfIconGap : props.gap
  return { gap: `${gap}px` }
})

const defaultActive = $computed(() => {
  if (businessPath.startsWith('/activity/worldCup')) {
    return 'worldCup'
  }

  const res = Object.keys(menuConfig).filter(key => {
    return businessPath.startsWith(`/${key}`)
  })[0]
  return res
})

const obRecharge = () => {
  // const curRoute = walletStore.menuMaps.find((obj) => obj.name === route.name)
  const obj = {
    path: '/home',
    title: 'header.home',
  }
  router.push({
    name: 'Recharge',
    query: { path: JSON.stringify([obj]) }
  })
}

let landingPageList = $ref([])
const getLandingPageList = async () => {
  try {
    const res = await activityApi.landingPageList()
    landingPageList = res
  } catch (error) {
    console.log('activityApi.landingPageList', error)
  }
}

const landingPageListClassName = (item) => {
  const now = Date.now()
  if (now < item.startTime) {
    return 'Upcoming'
  } else if (now >= item.startTime && now < item.endTime) {
    return 'Ongoing'
  } else if (now >= item.endTime) {
    return 'Ended'
  }
}

const openLink = (url) => {
  window.open(url, '_blank')
}

// 可以在组件挂载时获取数据
onBeforeMount(() => {
  getLandingPageList()
})

const newCoinActivities = computed(() => {
  const localeMap = {
    [LANGCN]: [],
    [LANGTW]: [],
    [LANGJA]: [],
    default: []
  }

  const currentLocale = configStore.locale === 'hk' ? LANGTW : configStore.locale
  return localeMap[currentLocale] || localeMap.default
})

watch(() => configStore.locale, () => {
  getLandingPageList()
})

</script>

<style lang="scss">
@use "sass:math";
@use "sass:map";
@import '@/sass/var/index.scss';

.header-ellipsis{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: 0;
}
.header-dropdown {
  &.el-popper {
    --el-popper-border-radius: 12px !important;
    border-radius: var(--el-popper-border-radius) !important;
  }

  .el-scrollbar__view,
  .el-dropdown-menu {
    border-radius: 12px !important;
    overflow: hidden !important;
  }

  .el-dropdown__list {
    padding: 12px !important;
  }
}

.header-activity-dropdown-scrollbar {
  :deep(.el-scrollbar__wrap) {
    overflow-y: auto !important;
  }
}

.header-activity-dropdown-content {
  overscroll-behavior: contain;
}

.header-stock-dropdown {
  .el-dropdown__list {
    width: 244px;
    box-sizing: border-box;
  }
}

.appheader-dropdown-item{
    width: 100%;
    height: 40px;
    font-size: 14px;
    padding: 0 20px;;
    cursor: pointer;
  }

.AppHeader {
  /* --header-nav-text: #16151A; */
  position: fixed;
  top:0;
  left:0;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding: 0 20px;
  background-color: #fff;
  font-size: 14px;
  z-index: 98;

  .header-hover-bg {
    border-radius: 999px;
    min-height: 32px;
    padding: 0 12px;
    transition: background-color 0.2s ease;

    &:hover {
      background-color: #2C2C2C;
    }
  }

  .header-round-hover-bg { //为右菜单准备
    &:hover {
      background-color: #2C2C2C;
    }
  }

  .nav-menu {
    height: 100%;
    align-items: center;
    .nav-item {
      padding: 0px;
      display: flex;
      align-items: center;
      /* color: var(--header-nav-text) !important; */
      font-weight: bold !important;
      font-size: 14px;
      height: 100%;
      cursor: pointer;
    }
    .nav-item-stock{
      width: 104px;
      height: 32px !important;
      background:linear-gradient(37.66deg, #FFFFFF 4.83%, #02F1C6 27.79%, #2649EF 86.77%) no-repeat center center;
      background-size: cover;
      border-radius: 32px;
      color: $color-white !important;
    }
  }
}
.landingPageList-status{
  .Ongoing{
    padding: 0 4px;
    height: 16px;
    background-color: $color-warning !important;
    border-radius: 8px;
    color: #fff;
  }
  .Ended{
    padding: 0 4px;
    height: 16px;
    background-color: #F4F4F4 !important;
    border-radius: 8px;
    color: #9B9B9B;
  }
  .Upcoming{
    padding: 0 4px;
    height: 16px;
    background-color: #FAAD3A1A !important;
    border-radius: 8px;
    color: #FAAD3A;
  }
  flex-shrink: 0;
}
</style>
